const implantology = {
  hero: {
    title: "IMPLANTOLOGY",
    description:
      "Our dental office provides high-quality, long-term tooth replacements that guarantee a natural appearance and feel, blending in perfectly with your natural teeth and greatly enhancing your oral health overall.",
    ctas: {
      bookConsultation: "Book Consultation",
      learnMore: "Learn More",
    },
    imageAlt: "Advanced dental implants",
    successRate: {
      title: "98% Success Rate",
      subtitle: "with our advanced implants",
    },
  },
  benefits: {
    heading: "WHY CHOOSE DENTAL IMPLANTS",
    intro:
      "Dental implants offer a permanent solution to missing teeth with benefits that go beyond aesthetics.",
    items: [
      {
        title: "Natural Look & Feel",
        description:
          "Implants provide the same stability and appearance as natural teeth, allowing you to smile, speak, and eat with confidence.",
      },
      {
        title: "Bone Health Preservation",
        description:
          "Unlike traditional dentures, implants stimulate bone growth and prevent bone loss that occurs when teeth are missing.",
      },
      {
        title: "Long-lasting Solution",
        description:
          "With proper care, dental implants can last a lifetime, making them a cost-effective solution in the long run.",
      },
    ],
  },
  process: {
    heading: "THE IMPLANT PROCESS",
    intro: "Our streamlined process ensures minimal discomfort and maximum results.",
    steps: [
      {
        title: "Consultation & Planning",
        description:
          "We begin with a comprehensive examination using advanced 3D imaging to assess your oral health and create a personalized treatment plan.",
      },
      {
        title: "Implant Placement",
        description:
          "Using state-of-the-art technology, we carefully place the titanium implant into the jawbone, which will serve as the root for your new tooth.",
      },
      {
        title: "Healing & Integration",
        description:
          "Over a period of 3-6 months, the implant fuses with your jawbone in a process called osseointegration, creating a stable foundation.",
      },
      {
        title: "Final Restoration",
        description:
          "Once healing is complete, we attach a custom-made crown that matches your natural teeth in color, shape, and size.",
      },
    ],
  },
  faq: {
    heading: "FREQUENTLY ASKED QUESTIONS",
    intro: "Get answers to common questions about dental implants",
    items: [
      {
        question: "Are dental implants painful?",
        answer:
          "Most patients report that the procedure is less painful than they expected. We use modern anesthesia and sedation options to ensure your comfort throughout the process. Post-procedure discomfort is typically mild and can be managed with over-the-counter pain medications.",
      },
      {
        question: "How long do dental implants last?",
        answer:
          "With proper care and maintenance, dental implants can last a lifetime. The crown may need replacement after 10-15 years due to normal wear and tear, but the implant itself can remain integrated with your jawbone indefinitely.",
      },
      {
        question: "Am I a good candidate for dental implants?",
        answer:
          "Most adults with good general health are candidates for dental implants. Important factors include having adequate bone density to support the implant and healthy gums. During your consultation, we'll evaluate your specific situation and discuss all available options.",
      },
      {
        question: "How do I care for my dental implants?",
        answer:
          "Dental implants require the same care as natural teeth: regular brushing, flossing, and dental check-ups. While they cannot develop cavities, the surrounding gum tissue can become infected without proper oral hygiene, so maintaining good oral health practices is essential.",
      },
    ],
    cta: "Schedule Your Consultation",
  },
};

export default implantology;

